
import CloudSnow from "../../../assets/duotone/CloudSnow.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudSnowIcon({ className, dataTestid = "CloudSnowIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudSnow data-testid={dataTestid} className={classes} {...rest} />
  );
}
